import { render, staticRenderFns } from "./lgyesenia.vue?vue&type=template&id=22312dd2&"
import script from "./lgyesenia.vue?vue&type=script&lang=js&"
export * from "./lgyesenia.vue?vue&type=script&lang=js&"
import style0 from "./lgyesenia.vue?vue&type=style&index=0&id=22312dd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports